const Utility = {
  fetchChildIds: async function(productHandle) {
        try {
            const response = await fetch(`/products/${productHandle}?view=childIds`);
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            const variantIds = await response.json();
            return variantIds;
          } catch (error) {
            console.error('Error fetching product data:', error);
            return null;
          }
    },
  
  fetchProductDataAjax: async function(productHandle, productType, childIds) {
        try {
            const response = await fetch(`/products/${productHandle}.js`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            let productData = await response.json();
    
            if (productType == 'Combined Paddle' && childIds) {    
                try {
                    const response = await fetch(`https://shopifyapis.azurewebsites.net/api/fetchAllVariants?code=Ya6jqLoN9yoe3GPsxnlwLWAN-cTe_9mZGNL9daXetJ5OAzFun22jzA%3D%3D&ids=${childIds.childProducts}`);
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
    
                    // Fetch all variants from the Azure function
                    const data = await response.json();
                    
                    // Flatten the variants array to remove any pagination-related chunks
                    const allVariants = data.flat(); // This will flatten any nested arrays within `data`
    
                    // Assign the flattened variants array to productData
                    productData.variants = allVariants;
    
                    return productData;
                } catch (error) {
                    console.error('Error fetching product data:', error);
                    return null;
                }   
            } else {
                return productData;
            }  
        } catch (error) {
            console.error('Error fetching product data:', error);
            return null;
        }   
    },

    fetchProductImages: async function(productHandle, variantId) {
      try {
          const response = await fetch(`/products/${productHandle}?view=var-images&variant=${variantId}`);
          if (!response.ok) {
              throw new Error('Network response was not ok');
              return null;
          }
          
          const productImages = await response.json();
          return productImages;
      } catch (error) {
          console.error('Error fetching product data:', error);
          return null;
      }
    },
      
    fetchProductDetails: async function(productHandle, variantId) {
      try {
          const response = await fetch(`/products/${productHandle}?view=data&variant=${variantId}`);
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          const productData = await response.json();
          return productData;
        } catch (error) {
          console.error('Error fetching product data:', error);
          return null;
        }
    },
    fetchEls: function(selectors, context) {
        Object.entries(selectors).forEach(([key, {selector, type, scope}]) => {
            if (type === 'single') {
                if (scope === 'document') {
                    context[key] = document.querySelector(selector);
                } else {
                    context[key] = context.parent.querySelector(selector);
                }
            } else if (type === 'all') {
                if (scope === 'document') {
                    context[key] = document.querySelectorAll(selector);
                } else {
                    context[key] = context.parent.querySelectorAll(selector);
                }
            }
        });
    },
    smoothScroll: function(element, distance, duration) {
      const startTime = performance.now();
      const startPos = element.scrollLeft;
      const maxScrollLeft = element.scrollWidth - element.clientWidth;
      
      // Ensure target position is within the bounds
      const targetPos = Math.max(0, Math.min(startPos + distance, maxScrollLeft));
    
      function scrollFrame(timestamp) {
        const elapsed = timestamp - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const newPosition = startPos + (targetPos - startPos) * progress;
        element.scrollLeft = newPosition;
    
        if (progress < 1) {
          requestAnimationFrame(scrollFrame);
        }
      }
    
      requestAnimationFrame(scrollFrame);
    }
};